<template>
  <div class="py-2">
    <div v-if="loading" class="text-muted">
      Načítám kalkulace zákazníka…
    </div>

    <div v-else-if="error" class="text-danger">
      Nepodařilo se načíst kalkulace zákazníka.
    </div>

    <div v-else>
      <div v-if="calculations.length === 0" class="text-muted">
        Zákazník nemá žádné kalkulace.
      </div>

      <ul v-else class="list-group">
        <li v-for="c in calculations" :key="c.uid" class="list-group-item d-flex justify-content-between">
          <div>
            <div class="fw-semibold">{{ c.number }} — {{ c.name }}</div>
            <div class="text-muted small">{{ c.created_at ? new Date(c.created_at).toLocaleDateString('cs-CZ') : '' }}</div>
          </div>
          <div class="text-muted small">
            {{ c.status }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps } from "vue";
import myApi from "@/api/api";

const props = defineProps({
  customerId: { type: Number, required: true },
  expanded: { type: Boolean, required: true },
});

const calculations = ref([]);
const loading = ref(false);
const error = ref(null);
const loadedOnce = ref(false);

const loadOnce = async () => {
  if (loadedOnce.value) return;

  loading.value = true;
  error.value = null;
  try {
    const result = await myApi.calculationListByCustomer(props.customerId, null);
    calculations.value = Array.isArray(result) ? result : [];
    loadedOnce.value = true;
  } catch (e) {
    error.value = e;
    calculations.value = [];
  } finally {
    loading.value = false;
  }
};

watch(
  () => props.expanded,
  (v) => {
    if (v) loadOnce();
  },
  { immediate: true }
);
</script>